module.exports = __webpack_public_path__ + "static/img/74.b93772f.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/news/gallery/23/74.jpg
// module id = 738
// module chunks = 0